export default "__VITE_ASSET__BwOBFRyy__"